import CustomCard from '@/components/customCard';
import RegularText from '@/components/RegularText';
import { TextField } from '@shopify/polaris';
import { useState } from 'react';

interface IProps {
  value?: string;
  onChange: (value: string) => void;
}

const RuleName = ({ value, onChange }: IProps) => {
  const [error, setError] = useState('');

  return (
    <CustomCard required={true} title={'Rule name'}>
      <div className="mb-8">
        <RegularText>Internal name only. Not visible to customers.</RegularText>
      </div>
      <TextField
        label=""
        labelHidden
        autoComplete="off"
        value={value}
        onChange={(value) => {
          onChange(value);
          if (error && value) setError('');
        }}
        onBlur={() => {
          if (!value) setError('This field is required');
        }}
        error={error}
      />
    </CustomCard>
  );
};

export default RuleName;
